import React from 'react';
import MessageItem from './MessageItem';

const MessageList = ({
  conversation,
  messages,
  isLoading,
  hasMore,
  isLoadingMore,
  topMessageRef,
  messagesContainerRef,
  translationStateByMessageId,
  onToggleTranslation,
  shouldOfferTranslation,
  onToggleLike,
  editingMessageId,
  editingContent,
  onEditingContentChange,
  onStartEditMessage,
  onCancelEditMessage,
  onSaveEditMessage,
  deletingMessageId,
  onRequestDeleteMessage,
  onCancelDeleteMessage,
  onConfirmDeleteMessage,
  isDeleting,
  isSavingEdit,
  onReportMessage,
  formatMessageDate,
  formatDayLabel,
  formatClientLabel,
  showScrollToLatest,
  onScrollToLatest,
}) => {
  const renderItems = () => {
    if (!Array.isArray(messages) || messages.length === 0) return null;

    const items = [];
    let lastDayKey = null;
    messages.forEach((message, index) => {
      const date = new Date(message.date);
      const dayKey = date.toDateString();
      if (dayKey !== lastDayKey) {
        const firstMessageKey = message._id || message.date || index;
        items.push({ type: 'divider', date, key: `div-${dayKey}-${firstMessageKey}` });
        lastDayKey = dayKey;
      }
      items.push({
        type: 'message',
        message,
        key: message._id || `${message.senderId}-${message.date}`,
      });
    });

    return items.map((item) => {
      if (item.type === 'divider') {
        return (
          <div key={item.key} className="message-day-divider">
            <span>{formatDayLabel(item.date)}</span>
          </div>
        );
      }
      const message = item.message;
      return (
        <MessageItem
          key={item.key}
          message={message}
          conversation={conversation}
          translationState={translationStateByMessageId[message._id]}
          onToggleTranslation={onToggleTranslation}
          shouldOfferTranslation={shouldOfferTranslation}
          onToggleLike={onToggleLike}
          editingMessageId={editingMessageId}
          editingContent={editingContent}
          onEditingContentChange={onEditingContentChange}
          onStartEditMessage={onStartEditMessage}
          onCancelEditMessage={onCancelEditMessage}
          onSaveEditMessage={onSaveEditMessage}
          deletingMessageId={deletingMessageId}
          onRequestDeleteMessage={onRequestDeleteMessage}
          onCancelDeleteMessage={onCancelDeleteMessage}
          onConfirmDeleteMessage={onConfirmDeleteMessage}
          isDeleting={isDeleting}
          isSavingEdit={isSavingEdit}
          onReportMessage={onReportMessage}
          formatMessageDate={formatMessageDate}
          formatClientLabel={formatClientLabel}
        />
      );
    });
  };

  return (
    <div className="messages-wrapper">
      <div className="messages-container" ref={messagesContainerRef}>
        {hasMore && !isLoading && (
          <div
            ref={topMessageRef}
            className={`message-loader ${isLoadingMore ? 'is-loading' : ''}`}
          >
            {isLoadingMore ? 'Chargement…' : ''}
          </div>
        )}

        {isLoading && (
          <p className="chat-detail-loading-message">Chargement des messages...</p>
        )}

        {!isLoading && messages.length === 0 && (
          <p className="chat-detail-empty">Aucun message dans cette conversation.</p>
        )}

        {renderItems()}
      </div>

      {showScrollToLatest && (
        <button
          className="scroll-to-latest"
          onClick={onScrollToLatest}
          aria-label="Aller au dernier message"
        >
          ↓
        </button>
      )}
    </div>
  );
};

export default MessageList;
